"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
var _utils = require("@/utils");
var _util = require("@/utils/util");
var _bookingHead = require("@/api/query/bookingHead");
var _impCargoInfo = require("@/api/query/impCargoInfo");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'cargoInfoSearch',
  data: function data() {
    return {
      loading: null,
      isCnLang: false,
      form: {
        blNo: '',
        containerNo: ''
      },
      rules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: 'blur'
        }],
        containerNo: [{
          required: true,
          message: this.$t('validate.containerNo'),
          trigger: 'blur'
        }]
      },
      baseData: {
        vesselName: '',
        voyageNo: '',
        pol: '',
        pod: '',
        eta: '',
        actualWordEndTime: '',
        releaseStatus: '',
        deliveryReleaseFlag: '',
        takeContainerLoc: '',
        exchahgerRate: ''
      },
      tableContainerData: [],
      tableFeeData: [],
      showResult: false,
      releaseTypeName: {
        '1': '提单已签发',
        '2': '已电放',
        '3': '海运单已签发',
        '4': '取消放单'
      },
      releaseTypeNameEn: {
        '1': 'ORIGINAL BL ISSUED',
        '2': 'SURRENDERED',
        '3': 'SEA WAYBILL ISSUED',
        '4': 'CANCEL&WITHDRAW'
      },
      changeTypeName: {
        '0': 'NO',
        '1': 'YES',
        '2': 'ALL'
      }
    };
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh-cn';
  },
  methods: {
    validateNull: _validate.validateNull,
    /**
     * 点击编号跳转界面
     * @param row
     */
    handleBLNo: function handleBLNo(blNo) {
      var routeUrl = this.$router.resolve({
        path: '/topMenu/equipmentFee',
        query: {
          blNo: blNo
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     *  费用合计
     **/
    getSummaries: function getSummaries(param) {
      var _this = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = _this.$t('equipmentFee.total');
          return;
        }
        if (index === 1) {
          var currencys = (0, _toConsumableArray2.default)(new Set(data.map(function (item) {
            return item.currency;
          })));
          if (currencys.length === 1) {
            var values = data.map(function (item) {
              return _this.moneyToNumFiled(item[column.property]);
            });
            sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
              return accumulator + pilot;
            }, 0));
          } else {
            var currentMoney = [];
            sums[index] = '';
            var i = 0;
            for (i = 0; i < currencys.length; i++) {
              currentMoney[i] = data.filter(function (item) {
                return item.currency === currencys[i];
              }).map(function (it) {
                return _this.moneyToNumFiled(it.amount);
              }).reduce(function (accumulator, pilot) {
                return accumulator + pilot;
              }, 0);
              sums[index] = sums[index] + (0, _util.toMoney)(currentMoney[i]) + '\n(' + currencys[i] + (i === currencys.length - 1 ? ')\n' : ')\n+');
            }
          }
        }
        if (index === 2) {
          var _values = (0, _toConsumableArray2.default)(new Set(data.map(function (item) {
            return item[column.property];
          })));
          if (_values.length === 1) {
            sums[index] = _values[0];
          } else {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    moneyToNumFiled: function moneyToNumFiled(obj) {
      var num = obj.trim();
      var ss = num.toString();
      if (ss.length === 0) {
        return '';
      }
      return isNaN(Number(ss.replace(/,/g, ''))) ? 0 : Number(ss.replace(/,/g, ''));
    },
    /**
     * 查询
     */
    toSearch: function toSearch() {
      var _this2 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this2.loading = (0, _utils.load)();
          (0, _bookingHead.checkBlNo)(_this2.form).then(function (response) {
            var res = response.data;
            if (res === 0) {
              _this2.$message.error({
                message: _this2.$t('validate.checkBlNo'),
                center: true,
                offset: 50
              });
            } else {
              _this2.resetData();
              (0, _impCargoInfo.cargoInfoSearch)({
                blNo: _this2.form.blNo,
                containerNo: _this2.form.containerNo
              }).then(function (response) {
                if (!_this2.validateNull(response.data)) {
                  var resultData = response.data;
                  var resultBaseData = resultData.base[0];
                  _this2.baseData.vesselName = resultBaseData.vesselName;
                  _this2.baseData.voyageNo = resultBaseData.voyageNo;
                  _this2.baseData.pol = resultBaseData.pol;
                  _this2.baseData.pod = resultBaseData.pod;
                  _this2.baseData.eta = resultBaseData.eta;
                  _this2.baseData.actualWordEndTime = resultBaseData.actualWordEndTime;
                  _this2.baseData.releaseStatus = resultBaseData.releaseStatus;
                  _this2.baseData.deliveryReleaseFlag = resultBaseData.deliveryReleaseFlag;
                  _this2.baseData.takeContainerLoc = resultBaseData.takeContainerLoc;
                  _this2.baseData.exchahgerRate = resultBaseData.exchahgerRate;
                  _this2.tableContainerData = resultData.cntrList;
                  _this2.tableFeeData = resultData.feeList;
                  _this2.showResult = true;
                }
              }).catch(function () {
                _this2.baseData = [];
                _this2.tableContainerData = [];
                _this2.tableFeeData = [];
                _this2.showResult = false;
              }).finally(function () {
                _this2.loading.close();
              });
            }
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    /**
     * 表格数据重置
     */
    resetData: function resetData() {
      this.baseData = {
        vesselName: '',
        voyageNo: '',
        pol: '',
        pod: '',
        eta: '',
        actualWordEndTime: '',
        releaseStatus: '',
        deliveryReleaseFlag: '',
        takeContainerLoc: '',
        exchahgerRate: ''
      };
      this.tableContainerData = [];
      this.tableFeeData = [];
    }
  }
};